import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getPlanzoneRole() {
      return getState().role;
    },
    isRetrievePlanzoneRoleRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrievePlanzoneRoleRequestPending() {
      return getState().request.isPending;
    },
    isRetrievePlanzoneRoleRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
